import { createFileRoute, Link, Outlet, useRouterState } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/reports")({
  component: ReportsLayout,
});

function ReportsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  const TABS = [
    { label: "Gestores de IA", to: "/reports/managers" },
    { label: "Análises de conversas", to: "/reports/conversations" },
  ] as const;

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {/* Topbar */}
      <div style={{ height: 52, borderBottom: "1px solid var(--line)", display: "flex", alignItems: "center", padding: "0 24px", flexShrink: 0 }}>
        <span style={{ fontSize: 15, fontWeight: 600 }}>Relatórios</span>
      </div>

      {/* Sub-nav tabs */}
      <div style={{ display: "flex", borderBottom: "1px solid var(--line)", flexShrink: 0, padding: "0 24px" }}>
        {TABS.map((tab) => {
          const active = pathname.startsWith(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              style={{
                padding: "10px 16px",
                fontSize: 13,
                color: active ? "var(--brand)" : "var(--ink-muted)",
                borderBottom: active ? "2px solid var(--brand)" : "2px solid transparent",
                fontWeight: active ? 500 : 400,
                marginBottom: -1,
                textDecoration: "none",
                transition: "color .12s, border-color .12s",
              }}
            >
              {tab.label}
            </Link>
          );
        })}
      </div>

      {/* Content */}
      <div style={{ flex: 1, overflowY: "auto", padding: "24px" }}>
        <Outlet />
      </div>
    </div>
  );
}
